import { Signal } from "signals";
import FlexiSlider from "slotworks/graphics/elements/flexi-slider";
import { SliderEvent } from "slotworks/graphics/elements/flexi-slider";
import FlexiText from "slotworks/graphics/elements/flexi-text";

export default class SliderComponent {

    public onChange: Signal;
    public onInput: Signal;

    public formatFunction: (value: number) => string;

    private slider: FlexiSlider;
    private label: FlexiText;

    private minLabel: FlexiText;
    private maxLabel: FlexiText;

    constructor(slider: FlexiSlider) {
        this.slider = slider;

        this.onChange = new Signal();
        this.onInput = new Signal();

        this.slider.setEnabled(true);

        this.slider.on(SliderEvent.INPUT, this.inputHandler);
        this.slider.on(SliderEvent.CHANGE, this.changeHandler);
    }

    public setup(min: number, max: number, step: number) {
        if (this.minLabel) {
            this.minLabel.setText(this.format(min));
        }

        if (this.maxLabel) {
            this.maxLabel.setText(this.format(max));
        }

        this.slider.setup(min, max, step);
    }

    public setValue(value: number) {
        this.slider.setValue(value);
        this.updateLabel();
    }

    public destroy() {
        if (this.slider) {
            this.slider.off(SliderEvent.INPUT, this.inputHandler);
            this.slider.off(SliderEvent.CHANGE, this.changeHandler);
            this.slider.destroy();
            this.slider = null;

            this.onInput.dispose();
            this.onChange.dispose();
            this.onInput = null;
            this.onChange = null;
        }
    }

    public setLabels(minLabel: FlexiText, maxLabel: FlexiText) {
        this.minLabel = minLabel;
        this.maxLabel = maxLabel;
    }

    public setVisible(visible: boolean) {
        this.slider.setVisible(visible);
        if (this.label) {
            this.label.setVisible(visible);
        }
        if (this.minLabel) {
            this.minLabel.setVisible(visible);
        }
        if (this.maxLabel) {
            this.maxLabel.setVisible(visible);
        }
    }

    public setEnabled(enabled: boolean) {
        this.slider.setEnabled(enabled);
    }

    private inputHandler = (value: number) => {
        if (this.onInput) {
            this.updateLabel();
            this.onInput.dispatch(value);
        }
    }

    private changeHandler = (value: number) => {
        if (this.onChange) {
            this.updateLabel();
            this.onChange.dispatch(value);
        }
    }

    private updateLabel() {
        if (this.label) {
            const value = this.slider.getValue();
            const text = this.format(value);

            this.label.setText(text);
        }
    }

    private format(value: number): string {
        if (this.formatFunction) {
            return this.formatFunction(value);
        } else {
            return value.toString();
        }
    }
}
